import React, {useState} from 'react';
import Accordion from "react-bootstrap/Accordion";
import './customAccordion.css'

function CustomAccordion({items = [], isFAQ=false}) {
    const [activeKey, setActiveKey] = useState(null);

    const handleToggle = (key) => {
        setActiveKey(activeKey === key ? null : key);
    };
    return (
        <>
            {isFAQ ?
                <Accordion
                    defaultActiveKey={activeKey}
                    className="custom-accordion"
                    onSelect={(key) => handleToggle(key)}
                >
                    {items.map((val, index) => {
                        return (
                            <Accordion.Item eventKey={val.id} className="custom-item" key={val.id}>
                                <Accordion.Header>
                                    <span className="header-text">{val.question}</span>
                                    <i className={`fa fa-chevron-down ${activeKey === val.id ? 'rotate' : ''}`}></i>
                                </Accordion.Header>
                                <Accordion.Body>
                                    {val.answer}
                                </Accordion.Body>
                            </Accordion.Item>
                        );
                    })}
                </Accordion>
                :
                <Accordion
                    defaultActiveKey={activeKey}
                    className="custom-accordion"
                    onSelect={(key) => handleToggle(key)}
                >
                    {items.map((val, index) => {
                        return (
                            <Accordion.Item eventKey={val.id} className="custom-item" key={val.id}>
                                <Accordion.Header>
                                    <span className="header-text">{val.title}</span>
                                    <i className={`fa fa-chevron-down ${activeKey === val.id ? 'rotate' : ''}`}></i>
                                </Accordion.Header>
                                <Accordion.Body>
                                    {val.description}
                                </Accordion.Body>
                            </Accordion.Item>
                        );
                    })}
                </Accordion>
            }
        </>
    );
}

export default CustomAccordion;